import { z } from 'zod';
import { type TicketStatus, TicketStatus as TST, type TicketStatusFilter } from './-query/type';
const ticketStatusValues = Object.values(TST) as [TicketStatus, ...TicketStatus[]];
export const TicketStatusFilterSchema = z.enum(['ALL', ...ticketStatusValues]);

/**
 * チケット一覧のステータスタブ並び順。
 * ワークフロー順 → 全件 → アーカイブ:
 *   OPEN → IN_PROGRESS → IN_REVIEW → DONE → CLOSED → ALL → ARCHIVED
 */
export const STATUS_TABS = [TST.OPEN, TST.IN_PROGRESS, TST.IN_REVIEW, TST.DONE, TST.CLOSED, 'ALL', TST.ARCHIVED] as const satisfies readonly TicketStatusFilter[];
export function buildTicketTabChangeSearch(tab: string) {
  const result = TicketStatusFilterSchema.safeParse(tab);
  return {
    status: result.success ? result.data : TST.OPEN,
    pageIndex: 0,
    sortColumn: undefined,
    orderDirection: 'desc' as const
  };
}